import { createGlobalStyle, css } from 'styled-components/macro';

export const GlobalStyles = createGlobalStyle`
  ${({ theme }) => css`
    :root {
      // Сброс переменной react-tooltip
      --rt-opacity: 1 !important;
    }

    * {
      -webkit-tap-highlight-color: transparent;
    }

    html,
    body {
      scroll-behavior: smooth;
    }

    body {
      margin: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-family: 'Roboto', sans-serif !important;
      box-sizing: border-box;
      background-color: ${theme.colors.gray[50]};
      --body-bg-color: ${theme.colors.gray[50]};
      color: ${theme.colors.gray[800]};
      word-break: break-word;
      overflow-wrap: break-word;
    }
    code {
      font-family: 'Roboto', sans-serif !important;
    }
    input,
    textarea,
    button,
    select {
      font-family: 'Roboto', sans-serif !important;

      &:autofill {
        box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.white} inset !important;
        -moz-text-fill-color: inherit !important;
      }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      padding: 0;
      margin: 0;
    }

    h1 {
      display: none;
    }

    h2 {
      color: ${theme.colors.gray[800]};
      font-feature-settings: 'liga' off;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
    }

    h3 {
      color: ${theme.colors.gray[800]};
      font-feature-settings: 'liga' off;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }

    h4 {
      color: ${theme.colors.gray[600]};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }

    h5 {
      color: ${theme.colors.gray[500]};
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }

    h6 {
      color: ${theme.colors.gray[400]};
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }

    .body-16 {
      font-size: 16px;
      line-height: 24px;
    }

    .body-14 {
      font-size: 14px;
      line-height: 20px;
    }

    .caption-13,
    .numbers-13 {
      font-size: 13px;
      line-height: 16px;
    }

    .numbers-13 {
      font-family: 'Roboto Mono', sans-serif;
    }

    .caption-11 {
      font-size: 11px;
      line-height: 12px;
    }

    .button-16 {
      font-size: 16px;
      line-height: 16px;
    }

    .button-14 {
      font-size: 14px;
      line-height: 16px;
    }

    .button-12 {
      font-size: 12px;
      line-height: 16px;
    }

    .tox-button {
      cursor: pointer !important;
      border-radius: 10px !important;
      font-weight: 400 !important;
      outline: none !important;
      font-size: 14px !important;
      padding: 8px 12px !important;
      border: 1px solid transparent !important;
      font-family: 'Roboto', sans-serif !important;
      line-height: 16px !important;
    }

    .react-datepicker-popper {
      z-index: 2000 !important;
    }

    .react-datepicker__month-text {
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 16px !important;
    }

    .react-datepicker__month-text--today {
      font-weight: normal !important;
    }

    .react-datepicker__month-text--keyboard-selected {
      font-weight: 500 !important;
    }

    .react-datepicker__header--time {
      padding-bottom: 8px !important;
    }
    .react-datepicker-time__header {
      font-size: 0 !important;
    }
    .react-datepicker-time__header:after {
      font-size: 15.104px;
      content: 'Время';
    }

    .react-datepicker__triangle {
      display: none !important;
    }

    .react-datepicker {
      padding: 8px !important;
      border: 1px solid #dfe5f2 !important;
      border-radius: 10px !important;
      box-shadow:
        0 3px 8px rgba(7, 31, 59, 0.06),
        0 8px 24px rgba(0, 32, 51, 0.12) !important;
      font-family: 'Roboto', sans-serif !important;
    }

    .react-datepicker__header {
      background-color: #ffffff !important;
      border-bottom: none !important;
    }

    .react-datepicker__navigation {
      top: 8px !important;
    }

    .react-datepicker__navigation--previous {
      outline: none !important;
    }

    .react-datepicker__navigation--next {
      outline: none !important;
    }

    .react-datepicker__input-container {
      text-align: center !important;
      display: flex !important;
      align-items: center !important;
    }

    .react-datepicker__input-container > input {
      color: #1f2939 !important;
    }

    .react-datepicker-year-header {
      font-weight: 500 !important;
    }

    .react-datepicker__current-month {
      font-size: 14px !important;
      color: #071f3b !important;
      font-weight: 500 !important;
      font-family: 'Roboto', sans-serif !important;
      padding-bottom: 10px !important;
    }

    .react-datepicker__current-month:first-letter {
      text-transform: uppercase !important;
    }

    .react-datepicker__day-name {
      color: #a8b3c1 !important;
    }

    .react-datepicker__month {
      color: #071f3b !important;
    }

    .react-datepicker__day--outside-month {
      color: #a8b3c1 !important;
    }

    .react-datepicker-time__header {
      font-size: 0 !important;
    }

    .react-datepicker-time__header:after {
      font-size: 14px !important;
      color: #071f3b !important;
      font-weight: 500 !important;
      font-family: 'Roboto', sans-serif !important;
      content: 'Время' !important;
    }

    .react-datepicker__time-list:focus {
      outline: none !important;
    }
    .react-datepicker__month-text {
      padding: 16px 0 !important;
      text-transform: capitalize !important;
    }

    /* Общий скроллбар */
    ::-webkit-scrollbar {
      width: 20px;
      background-color: transparent;
    }

    ::-webkit-scrollbar-track {
      margin-block: ${theme.spacings.xs};
      border-radius: ${theme.radiuses.full};
      border: 8px solid transparent;
      background-clip: padding-box;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.gray[200]};
      border-radius: ${theme.radiuses.full};
      border: 8px solid transparent; /* Такой же border как у track */
      background-clip: padding-box; /* Фон thumb тоже обрезается по border */

      &:hover {
        background-color: ${theme.colors.gray[500]};
      }
    }
  `}
`;
